import React, { useState, useEffect } from "react";
import "./Activities.css";
import { useNavigate, useLocation } from "react-router-dom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import Alert from "../../Components/Alert/Alert";
import AnswerOption from "../../Components/AnswerOption/AnswerOption";

export default function Activities() {
  const navigate = useNavigate();
  const location = useLocation();
  const { goal } = location.state || {};
  const initialActivityLevels = [
    {
      id: 0,
      title: "فعال نیستم",
      description: "بیشتر روز را نشسته می گذارنم (بدون هیچ ورزشی)",
      isChecked: false,
    },
    {
      id: 1,
      title: "کمی فعالم",
      description:
        "بخش زیادی از روز را به صورت ایستاده می گذرانم (به همراه 2 بار پیاده روی و ورزش هوازی در هفته)",
      isChecked: false,
    },
    {
      id: 4,
      title: "فعالم",
      description:
        "بخش زیادی از روز را به انجام برخی فعالیت های بدنی می گذرانم (به همراه 3 بار ورزش قدرتی در هفته)",
      isChecked: false,
    },
    {
      id: 5,
      title: "خیلی فعالم",
      description:
        "بیشتر روز را با فعالیت بدنی سنگین می گذرانم (به همراه بیش از 3 بار ورزش قدرتی در هفته)",
      isChecked: false,
    },
  ];
  const [activities, setActivities] = useState(initialActivityLevels);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const savedActivity = JSON.parse(localStorage.getItem("activity")) || "";
    if (savedActivity !== "") {
      handleCheckboxChange(savedActivity);
    }
  }, []);

  const handleCheckboxChange = (activityId) => {
    const updatedActivities = activities.map((activity) => ({
      ...activity,
      isChecked: false,
    }));

    const updatedActivity = activities.find(
      (activity) => activity.id === activityId
    );
    if (updatedActivity) {
      updatedActivity.isChecked = true;
    }

    setActivities(updatedActivities);
    setSelectedActivity(activityId);
  };

  const nextBtnHandler = () => {
    if (selectedActivity === null) {
      setShowModal(true);
      setTimeout(() => {
        setShowModal(false);
      }, 2000);
    } else {
      navigate("/age", { state: { goal, activity: selectedActivity } });
      localStorage.setItem("activity", JSON.stringify(selectedActivity));
    }
  };

  return (
    <div className="gymBg bgContainer">
      <div className="centeredFlex blurOverlay">
        <div className="pageHeader centeredFlex">
          <BackBtn />
        </div>
        <div className="userQuestionnaire ">
          <div className="userQuestionnaireTop scroll">
            <h3 className="activitiesHeading">سطح فعالیت روزانه شما ؟</h3>
            <div className="answerOptionsList">
              {activities.map((activity) => (
                <div
                  key={activity.id}
                  className="answerOptionItem activity centeredFlex"
                >
                  <div className="activityLevelTop centeredFlex">
                    <AnswerOption
                      optionKey={activity.id}
                      optionTitle={activity.title}
                      selectedOption={selectedActivity}
                      onCheck={(activityId) => handleCheckboxChange(activityId)}
                    />
                  </div>
                  <span className="activityDescription">
                    {activity.description}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="userQuestionnaireBottom centeredFlex">
            <Alert
              showAlert={showModal}
              alertText="لطفا سطح فعالیت خود را انتخاب کنید"
              bottom="5rem"
            />
            <button className="nextQuestion" onClick={nextBtnHandler}>
              بعدی
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
